export default function MobileSidebarDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
    const MENU_ITEMS = [
        {
            label: 'Dùng phiên bản nhanh',
            href: 'https://nhanh.thuocsi.vn/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20241fc25e65886b9d900a21cd1c43e4Vector.svg',
            border: true,
        },
        {
            label: 'Trang chủ',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202417bcbba552f0341b2bfc8d80bf34Homepage.svg',
        },
        {
            label: 'Sản phẩm',
            href: '/products',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20244ed8daf1c26e5805b0caba60a27cProduct_List.svg',
        },
        {
            label: 'Mã giảm giá',
            href: '/discounts',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202477e3937bbb7f3ba175e16bb3b8aaDiscount_Code.svg',
        },
        // {
        //     label: 'Nhà bán hàng',
        //     href: '/discounts',
        //     icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20247eff62dda604e97c9d2c33146589Store.svg',
        //     border: true,
        // },
        {
            label: 'Thông tin tài khoản',
            href: '/my-account',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20242b1077ae3edd4f241d118992599cAccount.svg',
        },
        {
            label: 'Tra cứu vận đơn',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024835e313a76842b25bf79d16bd924Tra_Cuu_Van_Don.svg',
        },
        {
            label: 'Phản hồi của tôi',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024c00d1ecfe5d2cba9321eb13a4792Feedback.svg?quality=100',
        },
        {
            label: 'Điểm tích lũy',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202418c5c9731d077f403ed8bea6e567Reward_Points.svg?quality=100',
        },
        {
            label: 'Thống kê',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024b223c77ec9e4a2325211046f527aTh%E1%BB%91ng_k%C3%AA.svg?quality=100',
        },
        {
            label: 'Tra cứu mã QR',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024187d6be604cac0decc8797a0c25eQR_Code_1.svg?quality=100',
        },
        {
            label: 'Sản phẩm đã xem',
            href: '/productviewed',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202424a3fab0d0c0dc1f82674f005739%C4%90%C3%A3_Xem.svg?quality=100',
        },
        {
            label: 'Sản phẩm quan tâm',
            href: '/user/wishlist',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024591e1eb1955bfe66ec2052569223Wishlist.svg?quality=100',
        },
        {
            label: 'Chương trình trả thưởng',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024d8cb09acdfc90a9f75deea6b14c4Cashback.svg?quality=100',
        },
        {
            label: 'Giới thiệu bạn bè',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024e8637f182eef0cd66590ff1ccfc7Invite.svg?quality=100',
            border: true,
        },
        {
            label: 'Hướng dẫn đặt hàng',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024f28288f68a04a1f65015eae04d25H%C6%B0%E1%BB%9Bng_d%E1%BA%ABn_%C4%91%E1%BA%B7t_h%C3%A0ng.svg?quality=100',
        },
        {
            label: 'Câu hỏi nhà thuốc',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024f18ca8051734a7c7d3fda38125b9C%C3%A2u_h%E1%BB%8Fi_nh%C3%A0_thu%E1%BB%91c_2.svg?quality=100',
        },
        {
            label: 'Hotro@thuocsi.vn',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20246d207c9af37207f8052ec70945fcMail.svg?quality=100',
        },
        {
            label: 'Thông tin chính sách',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20253caab1d5935de5b5e3bab398a0e6Policy-default.svg?quality=100',
        },
        {
            label: 'Đăng xuất',
            href: '/logout',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202463149845d7ad7baa5385dfc0e92bLog_Out.svg',
            border: true,
        },
    ]

    const SOCIALS = [
        { name: 'facebook', href: 'https://www.facebook.com/buymedvn', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/fb1.svg' },
        { name: 'tiktok', href: 'https://www.tiktok.com/@buymed.com', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/tiktok1.svg' },
        { name: 'linkedin', href: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg' },
        { name: 'zalo', href: 'https://zalo.me/1836616064223034882', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/zalo1.svg' },
    ]

    const CERTS = [
        {
            href: 'http://online.gov.vn/Home/WebDetails/52192',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'http://online.gov.vn/Home/AppDetails/2786',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'https://cystack.net/projects/buymed',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/cystack.svg',
        },
    ]


    if (!open) return null

    return (
        <div
            role="presentation"
            className="MuiDrawer-root MuiDrawer-modal styles_mobileSidebar_container__3f0CA"
            style={{ position: 'fixed', inset: 0, zIndex: 1300 }}
        >
            {/* Backdrop */}
            <div
                className="MuiBackdrop-root"
                aria-hidden="true"
                onClick={onClose}
                style={{ opacity: 1 }}
            />

            {/* Drawer */}
            <div
                className="MuiPaper-root MuiDrawer-paper MuiDrawer-paperAnchorLeft MuiPaper-elevation16"
                tabIndex={-1}
            >
                {/* HEADER */}
                <div className="styles_containerCustomter__OLYWi">
                    <h5 className="styles_textUser__5C_Vo">
                        Chào <span className="styles_textUserBold__utR2Q">Nhà thuốc Vũ Huy</span>
                    </h5>

                    <button
                        className="MuiButtonBase-root MuiIconButton-root styles_exitIcon__HOvIM"
                        type="button"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <img
                            src="https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/exit.svg"
                            alt="close"
                        />
                    </button>
                </div>

                {/* LEVEL / POINT */}
                <div className="styles_box2__OZLAt">
                    <div className="styles_table__h6VT9">
                        <div className="styles_quickView__MzeMa">

                            <div className="styles_leftInformation__cL_CO">
                                <h5 className="styles_textLevel__doJb0">Cấp bậc</h5>
                                <img
                                    src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/BAC.svg"
                                    alt="level"
                                />
                            </div>

                            <div className="styles_line__mpKHu" />

                            <div className="styles_rightInformation__UW9ZG">
                                <div className="styles_top__SN_GZ">
                                    <img
                                        src="https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/medal.svg"
                                        alt="medal"
                                    />
                                    <h6 className="styles_textLevel__doJb0">Điểm tích lũy</h6>
                                </div>
                                <div className="styles_bottom__SBZ6O">
                                    <h6 className="styles_textPoint__we2Bi">0</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* MENU LIST */}
                <div className="styles_groupTable__s_bK0">

                    {MENU_ITEMS.map((item, i) => (
                        <a
                            key={i}
                            className={`styles_mobile_rootBase__8z7PQ styles_navItem__SgbRN ${item.border ? 'styles_borderBottom__a5u7p' : ''}`}
                            href={item.href}
                        >
                            <img src={item.icon} alt="" />
                            <h6 className="styles_textName__OPCtF">{item.label}</h6>
                        </a>
                    ))}

                </div>

                {/* SOCIAL */}
                <div className="styles_groupSocialMedia__EkxTR">
                    <h6 className="styles_textSocialMedia__fMj76">Kết nối với chúng tôi</h6>
                </div>

                <div className="styles_groupSocialMedia__EkxTR">
                    {SOCIALS.map((s, i) => (
                        <a
                            key={i}
                            href={s.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="social media Link"
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'inline-block',
                                    overflow: 'hidden',
                                    width: 'initial',
                                    height: 'initial',
                                    background: 'none',
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: 'relative',
                                    maxWidth: '100%',
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'block',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: '100%',
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='24'%20height='24'/%3e"
                                        style={{
                                            display: 'block',
                                            maxWidth: '100%',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>

                                <img
                                    alt={s.name}
                                    src={s.icon}
                                    decoding="async"
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        boxSizing: 'border-box',
                                        padding: 0,
                                        border: 'none',
                                        margin: 'auto',
                                        display: 'block',
                                        width: 0,
                                        height: 0,
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                        minHeight: '100%',
                                        maxHeight: '100%',
                                    }}
                                />
                            </span>
                        </a>
                    ))}
                </div>

                {/* CERTIFICATE */}
                <div className="styles_groupCertificateIcons__wPSGG">
                    {CERTS.map((c, i) => (
                        <a
                            key={i} href={c.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Certificate Link"
                        >
                            <div className="styles_mt2__nKIhj">
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'inline-block',
                                        overflow: 'hidden',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: 'relative',
                                        maxWidth: '100%',
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: 'border-box',
                                            display: 'block',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: '100%',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='85'%20height='26'/%3e"
                                            style={{
                                                display: 'block',
                                                maxWidth: '100%',
                                                width: 'initial',
                                                height: 'initial',
                                                background: 'none',
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        src={c.icon}
                                        decoding="async"
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            boxSizing: 'border-box',
                                            padding: 0,
                                            border: 'none',
                                            margin: 'auto',
                                            display: 'block',
                                            width: 0,
                                            height: 0,
                                            minWidth: '100%',
                                            maxWidth: '100%',
                                            minHeight: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                        }}
                                        alt=""
                                    />
                                </span>
                            </div>
                        </a>

                    ))}
                </div>
            </div>
        </div>
    )
}
